import { type FC } from 'react';

import { useSvgId } from '@/hooks/use-svg-id';
import { type WithClassName } from '@/types/react';

type ProfileIconProps = WithClassName & {};

export const ProfileIcon: FC<ProfileIconProps> = (props) => {
  const { className } = props;

  const { id, idUrl } = useSvgId();

  return (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none">
      <g clipPath={idUrl}>
        <rect x="1" y="1" width="46" height="46" rx="23" fill="var(--dark-green1)" />

        <path
          d="M16 21.0248C16 16.5928 19.5817 13 24 13C28.4183 13 32 16.5928 32 21.0248C32 25.4567 28.4183 29.0495 24 29.0495C19.5817 29.0495 16 25.4567 16 21.0248Z"
          fill="var(--profile-icon-fill-color, var(--green-16p))"
        />

        <path
          d="M20 32.9505C13.3726 32.9505 8 38.3397 8 44.9876C8 47.2036 9.79086 49 12 49H36C38.2091 49 40 47.2036 40 44.9876C40 38.3397 34.6274 32.9505 28 32.9505H20Z"
          fill="var(--profile-icon-fill-color, var(--green-16p))"
        />
      </g>

      <rect
        x="0.5"
        y="0.5"
        width="47"
        height="47"
        rx="23.5"
        stroke="var(--profile-icon-stroke-color, var(--dark-green2-13p))"
      />

      <defs>
        <clipPath id={id}>
          <rect x="1" y="1" width="46" height="46" rx="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
